import { ambassadorClient } from '../../../lib';
import { getMetaSiteUrls as getMetaSiteUrlsHttp } from '@wix/ambassador-gg-store-setup-v1-store-setup-service/http';
import type { GetMetaSiteUrlsResponse } from '@wix/ambassador-gg-store-setup-v1-store-setup-service/types';

export async function getSiteUrls(_metaSiteId: string): Promise<string> {
  const response = await ambassadorClient.request<GetMetaSiteUrlsResponse>(getMetaSiteUrlsHttp({}));
  return response.data.metaSiteUrls?.primary?.url || '';
}
